import { Component, Input } from '@angular/core';

// campfire
import { ConfigService, TrustpilotService } from '@campfire-nx/api';

export interface IDataInterface {
  type?: string,
  settings?: ISettingsInterface
}

export interface ISettingsInterface {
  heading?: string,
  reviews?: Array<IReviewsInterface>
}

export interface IReviewsInterface {
  rating?: Number,
  title?: string,
  content: string,
  author: string
}
@Component({
  selector: 'app-product-trustpilot',
  templateUrl: './product-trustpilot.component.html',
  styleUrls: ['./product-trustpilot.component.scss']
})

export class ProductTrustpilotComponent {
  @Input() data!: IDataInterface;

  constructor(
    private trustpilotService: TrustpilotService,
    private configService: ConfigService
  ) { }

  ngAfterViewInit():void {
    const trustpilotOptions = {
      trustboxTemplate: this.configService?.data?.trustpilot?.trustboxMicro,
      businessunitId: this.configService?.data?.trustpilot?.huddleBusinessId
    };

    this.trustpilotService.init(['trustbox-rating-2'], trustpilotOptions);
  }
}
